(function() { window.GUID_bff79230_fdfe_4924_a96f_165b2d266b40 = { getGuid: function() { return "bff79230-fdfe-4924-a96f-165b2d266b40"; } }; })();
var CS;
(function (CS) {
    let DOM;
    (function (DOM) {
        DOM.$lastSectionMiddle = () => $(".section-middle").last();
        DOM.$lastTopbar = () => $(".section-top").last();
        DOM.$lastSubTopbar = () => $(".section-inner-subtop").last();
        /**This context is disposed on each navigation */
        function ViewContext() { return CS.Views.ViewBase.CurrentView; }
        DOM.ViewContext = ViewContext;
        function FindMainDOMElements() {
            CS.DOM.$doc = $(document);
            CS.DOM.$win = $(window);
            CS.DOM.$html = $('html');
            CS.DOM.$head = CS.DOM.$html.find('head');
            CS.DOM.$meta = CS.DOM.$html.find('meta');
            CS.DOM.$body = CS.DOM.$html.find('body');
        }
        DOM.FindMainDOMElements = FindMainDOMElements;
        function FindDOMSections() {
            var topBar = new CS.Controls.TopBar("#section-top");
            CS.DOM.$sectionMaster = $('#section-master');
            CS.DOM.$sectionMiddle = $('#section-middle');
            CS.DOM.$topBar = topBar.$TopBar;
            CS.DOM.$subTop = DOM.$sectionMaster.find("#section-sub-top");
            CS.DOM.$notificationContent = topBar.$NotificationsContent;
            CS.DOM.$sectionBottom = DOM.$sectionMaster.find('#section-bottom');
        }
        DOM.FindDOMSections = FindDOMSections;
        function RebindSectionMasterJQueryContents() {
            CS.DOM.$sectionMiddle = CS.DOM.$sectionMaster.find('#section-middle');
            CS.DOM.$sectionBottom = CS.DOM.$sectionMaster.find('#section-bottom');
        }
        DOM.RebindSectionMasterJQueryContents = RebindSectionMasterJQueryContents;
        function Refreshed() {
            requestAnimationFrame(function () {
                const $currentTopBar = $('.section-top').last();
                if ($currentTopBar.length > 0) {
                    if (CS.DOM.$sectionMaster && CS.DOM.$sectionMaster.css('position') == 'absolute') {
                        const $currentBottom = $('.section-bottom').last();
                        const $currentMiddle = $('.section-middle').last();
                        let top = $currentTopBar.is(':visible') ? $currentTopBar.outerHeight() : 0, bottom = $currentBottom.is(':visible') ? $currentBottom.outerHeight() : 0;
                        const $currentInnerSubTop = $(".section-inner-subtop").last();
                        if ($currentInnerSubTop.length > 0)
                            top += $currentInnerSubTop.outerHeight();
                        $currentMiddle.css({
                            top: `${top}px`,
                            bottom: `${bottom}px`
                        });
                    }
                }
                CS.Views.MasterPage.Instance.SetPersonaTheme();
                CS.Views.MasterPage.Instance.RefreshingCompleted();
            });
        }
        DOM.Refreshed = Refreshed;
        function AddDisposableClass($element) {
            if ($element != undefined) {
                $element.addClass('disposable');
            }
        }
        DOM.AddDisposableClass = AddDisposableClass;
        function DisposeChilds($container) {
            let $childs = $container.find('.disposable');
            $.each($childs, function () {
                let exist = $(this).data('instances');
                if (exist) {
                    for (var i = 0; i < exist.length; i++) {
                        let disposable = exist[i];
                        if (disposable) {
                            disposable.Dispose();
                        }
                    }
                }
            });
        }
        DOM.DisposeChilds = DisposeChilds;
        function AssignInstanceToJQueryElement(instance, $element = null) {
            if (!$element) {
                $element = this.$Control;
            }
            if ($element) {
                let exist = $element.data('instances');
                if (!exist) {
                    exist = new Array();
                }
                let replaced = false;
                //Evite un doublon d'instance, donc, pour le meme ID, ca remplace par le nouveau
                //Avant, ca l'ajoutait et la liste d'instance grossissait
                for (var i = 0; i < exist.length; i++) {
                    if (exist[i].ControlId == instance.ControlId) {
                        exist.splice(i, 1, instance);
                        replaced = true;
                    }
                }
                if (!replaced) {
                    exist.push(instance);
                }
                $element.data('instances', exist);
            }
        }
        DOM.AssignInstanceToJQueryElement = AssignInstanceToJQueryElement;
    })(DOM = CS.DOM || (CS.DOM = {}));
})(CS || (CS = {}));

//# sourceMappingURL=cs-dom.js.map
